import {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import {
  FolderDocumentContains,
  FolderDocumentUpdate,
  moveFolderData,
} from "./DocumentService";
import { Checkbox } from "primereact/checkbox";
import TosterService from "../../../Services/Toster-Service/TosterService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { RadioButton } from "primereact/radiobutton";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";

const MoveFolder = ({
  onMoveFolderClose,
  selectedMovedDocumentId,
  errorMessage,
  FolderId,
}) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [loading, setIsloading] = useState(false);
  const [allFolderData, setAllFolderData] = useState([]);
  const [selectedFolders, setSelectedFolders] = useState(null);
  const toster = useContext(TostMsg);
  // const [errorMessage, setErrorMessage] = useState("");
  const [errorMessagePopup, setErrorMessagePopup] = useState(false);
  const modalInstance = useRef();
  const modalRef = useRef();
  const [isOverride, setIsOverride] = useState(false);
  const [breadcrumb, setBreadcrumb] = useState([]);

  // useEffect(() => {
  //   setBreadcrumb(JSON.parse(localStorage.getItem("breadcrumbs")));
  // }, []);

  useEffect(() => {
    if (selectedMovedDocumentId > 0) {
      getFolderData(FolderId);
    }
    if (localStorage.getItem("breadcrumbs")) {
      setBreadcrumb(JSON.parse(localStorage.getItem("breadcrumbs")));
    } else {
      setBreadcrumb([{ id: 0, label: "Documents", LabelId: 0 }]);
    }
    setSelectedFolders(null);
  }, [selectedMovedDocumentId]);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }, []);

  async function getFolderData(folderId) {
    // selectedDocumentId
    setIsloading(true);
    const req = {
      Empid: userDetails?.EmpId,
      Type: 1,
      LabelId: folderId ? Number(folderId) : 0,
      Search: "",
      Id: 0,
      GUID: "",
      BookMarkedOnly: 0,
    };
    try {
      const responseData = await FolderDocumentContains(req);
      const data = responseData?.Data || [];
      sessionStorage.setItem("reload", true);
      const FolderData = data.filter((item) => {
        // const selectedDocument = breadcrumb[breadcrumb.length - 1];
        return (
          item?.DocTypeId === 101 &&
          item?.LabelId === Number(folderId) &&
          selectedMovedDocumentId !== item?.Id
        );
      });

      setAllFolderData(FolderData);

      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.GetFolder);
    }
  }

  async function moveFolder() {
    let req = {
      OrgId: userDetails?.OrgId,
      LabelId: selectedFolders ? Number(selectedFolders?.Id) : 0,
      Id: selectedMovedDocumentId ? selectedMovedDocumentId : 0,

      IsOverride: 0,

      LoggedInUserId: userDetails?.Id,
    };
    try {
      const responseData = await moveFolderData(req);

      setSelectedFolders(null);
      sessionStorage.setItem("reload", true);
      if (responseData?.StatusCode === 2000) {
        onMoveFolderClose({ close: true, success: 1 });

        GetMasterSystemAlertList("Doc_Move", 0);
      } else if (responseData?.StatusCode === 2003) {
        onMoveFolderClose({ close: true, success: 0 });
        errorMessage({
          Message: responseData?.Message,
          FolderId: req.Id,
          SelectedFolderId: req.LabelId,
        });
      } else {
        toster.current.error(responseData?.Message);
      }
    } catch (error) {
      toster.current.error(error.Message);
    }
  }

  useEffect(() => {
    if (errorMessagePopup) {
      modalInstance.current = new window.bootstrap.Modal(modalRef.current);
      modalInstance.current.show();
    }
  }, [errorMessagePopup]);

  const onBreadcrumbClick = (index) => {
    const selected = breadcrumb[index];

    if (breadcrumb.length !== index + 1) {
      setBreadcrumb((prev) => prev.slice(0, index + 1));
    }

    getFolderData(selected?.id);
  };

  async function navigateToAnotherFolder(document) {
    // await selectedMovedDocumentId(document?.Id);

    setBreadcrumb((prev) => [
      ...prev,
      {
        id: document?.Id,
        label: document?.DocName,
        LabelId: document?.LabelId,
      },
    ]);

    await getFolderData(document?.Id);
  }
  return (
    <>
      <div className="">
        {breadcrumb?.length > 0 && (
          <nav className="breadcrumb">
            {breadcrumb.map((item, index) => (
              <span
                key={index}
                className="breadcrumb-item"
                onClick={() => onBreadcrumbClick(index)}
              >
                <a
                  className={index < breadcrumb.length - 1 ? "c-pointer" : " "}
                >
                  {item?.label}
                </a>

                {index < breadcrumb.length - 1 && " "}
              </span>
            ))}
          </nav>
        )}
        <div className="row mt-3">
          <div className="edit-ticket mb-4 ">
            <div className="w-100">
              <div className="row">
                <div className="col-md-12 shrink-w">
                  <table class="table table-file-info ">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Folders </th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {allFolderData?.length !== 0 ? (
                        <>
                          {allFolderData?.map((document, index) => (
                            <tr>
                              <td scope="row">
                                <RadioButton
                                  inputId={document?.Id}
                                  name="document"
                                  value={document}
                                  onChange={(e) => setSelectedFolders(e.value)}
                                  checked={selectedFolders?.Id === document?.Id}
                                />
                                <label
                                  htmlFor={document?.Id}
                                  className="ml-2"
                                ></label>
                              </td>
                              <td>
                                <h6
                                  className="c-pointer"
                                  onClick={() => {
                                    //  selectedMovedDocumentId(document?.Id);
                                    navigateToAnotherFolder(document);
                                  }}
                                  title={document?.DocName}
                                >
                                  {document?.DocName.slice(0, 15)}
                                  {document?.DocName?.length > 15 && (
                                    <span>...</span>
                                  )}
                                </h6>
                                <p title={document?.DocDesc}>
                                  {document?.DocDesc.slice(0, 20)}
                                  {document?.DocDesc?.length > 20 && (
                                    <span>...</span>
                                  )}
                                </p>
                              </td>
                              <td>
                                {moment(
                                  document?.CreatedDate.split("T")[0]
                                ).format("MMM DD YYYY")}{" "}
                              </td>
                              <td>
                                <div className="document-by-profile">
                                  <LazyImage
                                    alt={document?.ModifiedByName}
                                    src={document?.ModifiedProfileImage}
                                    width="32"
                                  />
                                </div>
                                <span>{document?.ModifiedByName}</span>
                              </td>
                            </tr>
                          ))}
                        </>
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-3">
                            No folders here
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <div className="col-md-12">
                    <div className="btns-grp">
                      <button
                        type="button"
                        className="cancelbtn-click"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="savebtn-click btn-purple rounded"
                        onClick={moveFolder}
                        disabled={
                          allFolderData?.length === 0 ||
                          selectedFolders === null
                        }
                      >
                        Move here
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
export default MoveFolder;
